export default __webpack_public_path__ + "static/media/_ic_dark.b53acf28.svg";